<template>
  <v-card>
    <v-card-title><h2 class="text-h4">{{$t('webboxes.code.title')}}</h2></v-card-title>
    <v-card-text>
    <v-tabs v-model="tab">
    <v-tab>{{$t('webboxes.code.js.title')}}</v-tab>
    <v-tab :disabled="!customCss">{{$t('webboxes.code.css.title')}}</v-tab>
    </v-tabs>
    <v-tabs-items class="mt-2" v-model="tab">
    <v-tab-item>
    <p v-html="$t('webboxes.code.js.text')"></p>
    <p v-if="backend" v-html="$t('webboxes.code.js.update')"></p>
    <p v-else v-html="$t('webboxes.code.js.updateManual')"></p>
    <code-block language="html" :code="js" as-text>
    </code-block>
    </v-tab-item>
    <v-tab-item>
    <p>{{$t('webboxes.code.css.text')}}</p>
    <code-block language="css" :code="css">
    </code-block>
    </v-tab-item>
    </v-tabs-items>
    </v-card-text>
    </v-card>
</template>

<script>

import CodeBlock from "@/components/CodeBlock"

export default {
    name: 'WebboxCodeOther',
    components: {CodeBlock},
    props: { customCss: Boolean, js: String, css: String, box: String, backend: Boolean },
    data() {
        return {
            tab: null
        }
    } 
}
</script>

<style>

</style>